/* eslint-disable max-len */
import React, {useContext, useEffect, useState} from 'react';
import * as PIXI from 'pixi.js';
import '@pixi/unsafe-eval';
import {BlurFilter, Texture} from 'pixi.js';
import {Stage, Container, Sprite, Text, useTick, useApp, AnimatedSprite} from '@pixi/react';
import {PositionContext} from '@utils/context';
import {env} from 'next-runtime-env';
import {getControlPoint, calculatePerpendicularPoint, twoBezier} from '../helper';

interface JetFighterProps {
  onAnimationComplete: () => void;
  stageWidth: number;
  stageHeight: number;
  scaleUpValue: number;
  firstAnimation: PIXI.Texture[];
  secondAnimation: PIXI.Texture[];
  senderPosition: number;
  receiverPosition: number;
  canvasPosition: any;
  playerIconCenterPositions: any;
  timestamp: number;
}

const JetFighter = React.memo((props: JetFighterProps) => {
  const {
    stageWidth,
    stageHeight,
    onAnimationComplete,
    scaleUpValue,
    firstAnimation,
    secondAnimation,
    senderPosition,
    receiverPosition,
    canvasPosition,
    playerIconCenterPositions,
  } = props;
  // TODO
  const startPosition = {
    y: playerIconCenterPositions[senderPosition]?.y - canvasPosition?.top,
    x: playerIconCenterPositions[senderPosition]?.x - canvasPosition?.left,
  };
  const endPosition = {
    y: playerIconCenterPositions[receiverPosition]?.y - canvasPosition?.top,
    x: playerIconCenterPositions[receiverPosition]?.x - canvasPosition?.left,
  };
  // TODO remember to deduct it
  const initialPoint: [number, number] = [startPosition?.x, startPosition?.y];
  const targetPoint: [number, number] = [endPosition?.x, endPosition?.y];

  const [spritePosition, setSpritePosition] = useState({
    x: initialPoint[0],
    y: initialPoint[1],
  });
  const [elapsedTime, setElapsedTime] = useState(0);
  const [currentAnimation, setCurrentAnimation] = useState<number>(1);
  const [spriteAngle, setSpriteAngle] = useState<number>(0);
  const [curveIntensity, setCurveIntensity] = useState<number>(0);

  const toDegrees = (radians: number): number => {
    return radians * (180 / Math.PI);
  };

  useEffect(() => {
    const randomIntensity = Math.random() * 0.89 + 0.01;
    setCurveIntensity(randomIntensity);
  }, []);

  useTick(delta => {
    const animationDisplayTime = 100;
    const t = Math.min(elapsedTime / animationDisplayTime, 1);
    if (firstAnimation.length !== 0) {
      if (currentAnimation === 1) {
        setElapsedTime(prevElapsedTime => prevElapsedTime + delta);
        const controlPoint = calculatePerpendicularPoint(
          {x: initialPoint[0], y: initialPoint[1]},
          {x: targetPoint[0], y: targetPoint[1]},
          {width: stageWidth, height: stageHeight},
          curveIntensity
        );
        const [xt, yt] = twoBezier({
          p1: initialPoint,
          p2: targetPoint,
          t,
          c1: [controlPoint.x, controlPoint.y],
        });
        setSpritePosition({x: xt, y: yt});

        const dx = endPosition.x - xt;
        const dy = endPosition.y - yt;
        const angle = toDegrees(Math.atan2(dy, dx));
        const adjustedAngle = (angle + 90) % 360;
        setSpriteAngle(adjustedAngle);

        // setIsPlay(false);
        if (t >= 1) {
          setCurrentAnimation(2);
          setElapsedTime(0);
        }
      } else if (currentAnimation === 2) {
        // TODO set animation time
        setElapsedTime(prevElapsedTime => prevElapsedTime + delta);
        setSpritePosition({x: endPosition?.x, y: endPosition?.y});
        if (t >= 1) {
          onAnimationComplete();
          // setElapsedTime(0);
          // setSpritePosition({x: null, y: null});
        }
      }
    }
  });

  //! otherwise type error
  if (
    firstAnimation.length === 0 ||
    elapsedTime === 0 ||
    (spritePosition.x === 0 && spritePosition.y === 0) ||
    (spritePosition.x === null && spritePosition.y === null)
  ) {
    return null;
  }
  return (
    <AnimatedSprite
      height={(currentAnimation === 1 ? 75 : 145) * scaleUpValue}
      width={(currentAnimation === 1 ? 75 : 145) * scaleUpValue}
      animationSpeed={currentAnimation === 1 ? 2 : 1}
      textures={currentAnimation === 1 ? firstAnimation : secondAnimation}
      anchor={0.5}
      x={spritePosition.x}
      y={spritePosition.y}
      // TODO
      onComplete={onAnimationComplete}
      angle={senderPosition === receiverPosition ? 0 : spriteAngle}
      isPlaying
      loop={currentAnimation === 1}
      // scale={currentAnimation === 1 ? 0.4 : 1}
      // isPlaying={isPlay}
      // rotation={0.9}
      // rotation={rot}
      // textures={frames}
      // initialFrame={0}
      // x={200}
      // y={200}
      // isPlaying
      // loop={false}
      // loop={currentAnimation === 1}
    />
  );
});

JetFighter.displayName = 'JetFighter';

export default JetFighter;

// const spriteInitialX = spriteStartPosition?.x;
// const spriteInitialY = spriteStartPosition?.y;

// const FIGHTER_JSON = 'https://pixijs.io/examples/examples/assets/spritesheet/fighter.json';
// const FIGHTER_SPRITE = 'https://pixijs.io/examples/examples/assets/spritesheet/fighter.png';
// const EXPLOSION_JSON = 'https://pixijs.io/examples/examples/assets/spritesheet/mc.json';
// const EXPLOSION_SPRITE = 'https://pixijs.io/examples/examples/assets/spritesheet/mc.png';

// useTick(delta => {
//   const animationMovementTime = 100;
//   const t = Math.min(elapsedTime / animationMovementTime, 1);
//   if (shouldStickerBeMoved && animationTexture.length !== 0) {
//     setElapsedTime(prevElapsedTime => prevElapsedTime + delta);
//     const controlPoint = calculatePerpendicularPoint(
//       {x: spriteStartPosition.x, y: spriteStartPosition.y},
//       {x: spriteEndPosition.x, y: spriteEndPosition.y},
//       {width: stageWidth, height: stageHeight},
//       0.5
//     );
//     const [xt, yt] = twoBezier({
//       p1: initialPoint,
//       p2: targetPoint,
//       t,
//       c1: [controlPoint.x, controlPoint.y],
//     });
//     setSpritePosition({x: xt, y: yt});
//     setRot(prevRot => prevRot + 0.1 * delta);
//     setIsPlay(false);
//     if (t === 1) {
//       setCurrentAnimation(2);
//       setIsPlay(true);
//       // onAnimationComplete();
//       setTimeout(() => {
//         onAnimationComplete();
//         setElapsedTime(0);
//         setSpritePosition({x: null, y: null});
//       }, 2000);
//     }
//   }
// });
